import { Box, Link } from "@mui/material";
import { POINT_ICON } from "../../assets";
import { INSTRUCTION_DATA, useInstructionData } from "./instructionData";
import { useLiveDateTime } from "../../utils/liveDateTime";
import GlobalModal from "../../components/Modal";

const HEADER_HEIGHT = 56; // px
const FOOTER_HEIGHT = 72; // px

const Instructions = () => {
  const { formattedDateTime } = useLiveDateTime();

  const { openModal, setOpenModal, tncChecked, setTncChecked } =
    useInstructionData();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        bgcolor: "#f5f6fa",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "auto",
      }}
    >
      {/* Main content wrapper, always centered and max 400px */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "400px",
          height: "100vh",
          overflowY: "auto",
          bgcolor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: { xs: "0", sm: "20px" },
          boxShadow: { xs: "none", sm: "0 10px 24px rgba(0,0,0,0.08)" },
          position: "relative",
          display: "flex",
          flexDirection: "column",
          px: { xs: 0, sm: 0 },
        }}
      >
        {/* Sticky header */}

        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            bgcolor: "#fff",
            width: "100%",
            minHeight: `${HEADER_HEIGHT}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: "16px",
            borderRadius: { xs: 0, sm: "20px 20px 0 0" },
            borderBottom: "1px solid #e0e0e0",
            boxSizing: "border-box",
            py: 1,
          }}
        >
          {formattedDateTime}
        </Box>

        {/* Scrollable instructions area */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 3,
            pt: 3,
            pb: `${FOOTER_HEIGHT + 16}px`,
            boxSizing: "border-box",
            width: "100%",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {INSTRUCTION_DATA.INSTRUCTIONS.map((item, key) => (
            <Box
              key={key}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mb: 3,
                gap: 1.5,
              }}
            >
              <img
                src={POINT_ICON}
                alt="Points Icon"
                className="intructions-point-icon"
                height={16}
                width={16}
                style={{ marginTop: 4 }}
              />
              <Box>
                <div
                  style={{ fontSize: "15px", fontWeight: 500, marginBottom: 2 }}
                >
                  {item.englishText}
                </div>
                <div style={{ fontSize: "14px", color: "#555" }}>
                  {item.hindiText}
                </div>
              </Box>
            </Box>
          ))}

          <Box
            sx={{
              width: "100%",
              maxWidth: "400px",
              margin: "0 auto",
              px: 3,
              pb: 2,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              bgcolor: "#eaf3fb",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,51,102,0.06)",
              mt: 2,
            }}
          >
            <div
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#003366",
                marginBottom: 6,
                letterSpacing: "0.2px",
              }}
            >
              To check your IMEI number, dial:
            </div>
            <span
              style={{
                fontFamily: "monospace",
                fontWeight: 700,
                fontSize: "36px",
                color: "#1976d2",
                background: "#fff",
                borderRadius: "8px",
                padding: "6px 24px",
                boxShadow: "0 1px 4px rgba(25,118,210,0.08)",
                display: "inline-block",
                marginBottom: 4,
                letterSpacing: "2px",
              }}
            >
              *#06#
            </span>
          </Box>
        </Box>

        {/* Fixed footer button */}
        <Box
          sx={{
            position: "fixed",
            left: "50%",
            bottom: 0,
            transform: "translateX(-50%)",
            width: "100vw",
            maxWidth: "400px",
            bgcolor: "#fff",
            borderTop: "1px solid #e0e0e0",
            py: 1.5,
            zIndex: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: `${FOOTER_HEIGHT}px`,
            boxSizing: "border-box",
          }}
        >
          <Link
            href="tel:*#06#"
            underline="none"
            color="#fff"
            sx={{
              display: "block",
              border: "1px solid #003366",
              background: "#003366",
              fontSize: "20px",
              borderRadius: "8px",
              padding: "14px 0",
              width: "92%",
              maxWidth: "340px",
              textAlign: "center",
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              letterSpacing: "0.5px",
            }}
          >
            Record Your IMEI
          </Link>
        </Box>
      </Box>
      <GlobalModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onProceed={() => setOpenModal(false)}
        title={INSTRUCTION_DATA.MODAL.title}
        gif={INSTRUCTION_DATA.MODAL.gif}
        checkboxLabel={INSTRUCTION_DATA.MODAL.checkboxLabel}
        checkboxChecked={tncChecked}
        onCheckboxChange={setTncChecked}
        proceedLabel={INSTRUCTION_DATA.MODAL.proceedLabel}
      />
    </Box>
  );
};

export default Instructions;
